import React, { Component } from "react";
import { Trans, withTranslation } from "react-i18next";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { withStyles } from "@material-ui/core/styles";
import { FilePond, registerPlugin } from "react-filepond";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { connect } from "react-redux";
import DoneIcon from "@material-ui/icons/Done";
import UploadError from "../messages/UploadError";

const styles = (theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const getTransKeyFromHttpStatus = (status, message) =>{
  let translationKey = "unexpected_upload_error";
  switch(status){
    case 409:
      translationKey="virus_detected_in_file"
      break;
    case 413:
      translationKey="file_too_big_to_process"
      break;
    case 418: 
      // I'm a teapot. 
      // Temporary method to handle internal 500 errors. See UV6-1207 
      // Error type is propagated as a translation key
      // First characters are the Http status it prepresents
      // e.g. 500_AV_NOT_DEFINED
      if(!!message && message.length>0){
        translationKey = message;
      }
  }
  return translationKey;
}

export class SuggestGlobalAttachmentDialog extends Component {
  state = {
    open: true,
    files: [],
    description: "",
    uploaded: false,
    uploadError: null,
  };
  render() {
    const { classes, t } = this.props;
    return (
      <div>
        <Dialog onClose={this.props.onClose} open={this.state.open} fullWidth>
          <DialogTitle>
            <Trans i18nKey="suggest_global_attachment_header" />
            <IconButton
              aria-label="Close"
              className={classes.closeButton}
              onClick={this.props.onClose}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Typography variant="subtitle1">
              <Trans i18nKey="suggest_global_attachment_subheader" />
            </Typography>
            <TextField
              label={t("manage_attachments_description")}
              value={this.state.description}
              onChange={this.handleDescriptionChange}
              margin="normal"
              disabled={this.state.descriptionDisabled}
              fullWidth
            />
            {this.state.description.length === 0 && (
              <Typography style={{ marginBottom: 15 }}>
                <Trans i18nKey="manage_attachments_enter_description_before_upload" />
              </Typography>
            )}
            <FilePond
              ref={(ref) => (this.pond = ref)}
              files={this.state.files}
              allowMultiple={false}
              allowRevert={false}
              server={{
                process: (
                  fieldName,
                  file,
                  metadata,
                  load,
                  error,
                  progress,
                  abort,
                  transfer,
                  options
                ) => {
                  const formData = new FormData();
                  formData.append("file", file, file.name);
                  formData.append(
                    "contentAttachmentDTO",
                    JSON.stringify({
                      globalRequest: true,
                    })
                  );
                  const request = new XMLHttpRequest();
                  request.withCredentials = true
                  request.open(
                    "POST",
                    `https://${
                      this.props.apiLocation
                    }/attachmentservice/attachment/upload/`
                  );
                  request.upload.onprogress = (e) => {
                    progress(e.lengthComputable, e.loaded, e.total);
                  };
                  request.onload = () => {
                    let payload = JSON.parse(request.responseText);
                    if (request.status >= 200 && request.status < 300) {
                      load(payload.id);
                    } else{
                      let key = getTransKeyFromHttpStatus(request.status, payload.message);
                      error(t(key));
                      this.setState({ uploadError: key });
                    }
                  };
                  request.send(formData);
                  return {
                    abort: () => {
                      request.abort();
                      abort();
                    },
                  };
                },
              }}
              onprocessfile={(err) => {
                if (!err) {
                  this.setState({ uploaded: true });
                }
              }}
              onupdatefiles={(fileItems) => {
                // Set currently active file objects to this.state
                this.setState({
                  files: fileItems.map((fileItem) => fileItem.file),
                  descriptionDisabled: fileItems.length === 1,
                });
              }}
              onaddfilestart={(file) => {
                file.setMetadata("description", this.state.description);
                file.setMetadata("isGlobal", false);
                file.setMetadata("globalRequest", true);
              }}
            />

            {this.state.uploaded && (
              <Typography>
                <DoneIcon />{" "}
                <Trans i18nKey="suggest_global_attachment_request_received" />{" "}
                <a
                  href="javascript:undefined"
                  onClick={this.uploadAnotherAttachment}
                >
                  <Trans i18nKey="suggest_global_attachment_create_new_request" />
                </a>
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.onClose} color="primary">
              <Trans i18nKey="global_close" />
            </Button>
          </DialogActions>
        </Dialog>
        <UploadError
          uploadError={this.state.uploadError}
          setUploadError={() => this.setState({ uploadError: null })}
        />
      </div>
    );
  }

  uploadAnotherAttachment = () => {
    this.setState({ uploaded: false, files: [], description: "" });
  };

  handleDescriptionChange = (e) => {
    this.setState({ description: e.target.value });
  };
}
const mapStateToProps = (state) => ({
  message: state.setting.message,
  apiLocation: state.setting.apiLocation,
});

const mapDispatchToProps = {};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(SuggestGlobalAttachmentDialog)));
